import React, { Component } from 'react'
import { observer, Provider } from 'mobx-react'
import Setting from './Setting'
import Store from './store'
import { MENU_TYPE } from './constant'
import Menu from './Menu'
import { isNewOpen } from '@util'
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.pathname)
  }

  componentDidMount() {
    this.store.initMenu()
    this.store.getMenuIds()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pathname !== this.props.pathname) {
      this.store.setMenuData(this.props.pathname)
    }
  }

  menuHasAuth = (authMenuIds = [], id) => {
    return authMenuIds.includes(id)
  }

  getMenu = (data, authMenuIds = []) => {
    const menu = data.filter(Boolean).map((item, index, arr) => {
      if (!this.menuHasAuth([...authMenuIds], item.id)) {
        return null
      }

      let node

      if (item.type === MENU_TYPE.ITEM_GROUP) {
        const nextItem = arr[index + 1]
        const nextIsMenuItem =
          nextItem &&
          this.menuHasAuth([...authMenuIds], nextItem.id) &&
          nextItem.type !== MENU_TYPE.ITEM_GROUP
        node = (
          <Menu.ItemGroup
            key={item.id}
            item={item}
            nextIsMenuItem={nextIsMenuItem}
          >
            {(item.sub || []).filter(Boolean).map(i => {
              if (!this.menuHasAuth(authMenuIds, i.id)) {
                return null
              }
              return <Menu.Item key={i.id} item={i} />
            })}
          </Menu.ItemGroup>
        )
      } else if (Array.isArray(item.sub) && item.sub.length > 0) {
        node = (
          <Menu.SubMenu key={item.id} item={item}>
            {this.getMenu(item.sub, authMenuIds)}
          </Menu.SubMenu>
        )
      } else {
        node = <Menu.Item key={item.id} item={item} />
      }

      return item.render ? item.render(item, node) : node
    })
    return menu
  }

  render() {
    const { MENU, authMenuIds } = this.store

    return (
      <Provider menuStore={this.store}>
        <Menu bottom={!isNewOpen() && <Setting />}>
          {this.getMenu(MENU, authMenuIds)}
        </Menu>
      </Provider>
    )
  }
}
